// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1fbdy","topBottomGutter":"Layout_topBottomGutter__2Vw3G"};